module.exports = __webpack_public_path__ + "img/camera.e359a163.svg";